export const FETCH_RESULT_VN1 = 'FETCH_RESULT_VN1';
export const LIST_RESULT_VN1 = 'vnone';
export const DRAW_RESULT_VN1 = 'DRAW_RESULT_VN1';

